<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { onMounted, computed } from "vue";
import { useCharterStore } from "@/stores/charterStore";

const { t } = useI18n();
const charterStore = useCharterStore();

onMounted(() => {
  charterStore.fetchCharterBundles();
});

const charters = computed(() => charterStore.charterBundles);
const isLoading = computed(() => charterStore.loadingCharters);
</script>

<template>
  <div class="container">

    <span class="responsive-title-2 block">{{ t("charter.title") }}</span>

    <!-- Loading State -->
    <div v-if="isLoading" class="text-center py-8">
      Loading charters...
    </div>
    
    <div v-else class="pt-8 flex flex-col gap-4">
      <span class="font-semibold responsive-title-6">{{ t("charter.subtitle") }}</span>
      <div class="flex flex-col md:flex-row gap-6 justify-between">
        <div
            v-for="charter in charters"
            :key="charter.id"
            class="flex flex-col gap-2 w-full relative"
        >
          <!-- Image Container -->
          <div class="relative">
            <img
                :src="charter.imageSet['max']"
                :alt="charter.title"
                class="rounded-2xl w-full h-[195px] sm:h-[265px] object-cover"
            />
            <!-- Button Overlay -->
            <a
                :href="charter.url"
                class="absolute bottom-4 right-4 bg-blue-500 text-white rounded-full px-5 py-2 flex items-center justify-center shadow-md transition transform hover:scale-110"
            >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="w-5 h-5"
              >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </a>
          </div>
          <span class="text-lg font-semibold">{{ charter.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>